import { html } from '@utils/rendering/html';

import { useApiKeysContext } from './context/api-keys.context';

import ActionsDropdown from '@shared/components/dropdowns/actions-dropdown';
import ActionsDropdownItem from '@shared/components/dropdowns/actions-dropdown/actions-dropdown-item';
import { Icon, IconNames } from '@shared/components/icons';

export default function ApiKeysActions(row) {
    const isActive = row.isActive;

    const { isSubmitting, handleActivateKey, handleInvalidateKey, handleExtendKey } =
        useApiKeysContext();

    return html`
        <${ActionsDropdown}>
            ${
                isActive
                    ? html`
                          <${ActionsDropdownItem}
                              disabled=${isSubmitting}
                              onClickEvent=${() => handleInvalidateKey(row.keyId)}
                              params=${null}
                              label=${{
                                  text: 'Deactivate Key',
                                  icon: html`<${Icon} name=${IconNames.Block} />`,
                              }}
                          />
                          <${ActionsDropdownItem}
                              disabled=${isSubmitting}
                              onClickEvent=${() => handleExtendKey(row.keyId)}
                              params=${null}
                              label=${{
                                  text: 'Extend Expiry Date',
                                  icon: html`<${Icon} name=${IconNames.Alarm} />`,
                              }}
                          />
                      `
                    : html`
                          <${ActionsDropdownItem}
                              disabled=${isSubmitting}
                              onClickEvent=${() => handleActivateKey(row.keyId)}
                              params=${null}
                              label=${{
                                  text: 'Activate Key',
                                  icon: html`<${Icon} name=${IconNames.CheckCircle} />`,
                              }}
                          />
                      `
            }
        </${ActionsDropdown}>
    `;
}
